import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6","key":"svg-0"}]]

const IconOvalVertical = createReactComponent('outline', 'oval-vertical', 'OvalVertical', __iconNode);

export default IconOvalVertical;